module.exports = __webpack_public_path__ + "img/swiper_nav3.d2a87d01.png";